<template>
  <span>
    <custom-text-input
      v-if="
        type === 'text' ||
        type === 'email' ||
        type === 'message' ||
        type === 'date'
      "
      ref="input"
      v-model="inputValue"
      :custom-type="type"
      :custom="custom"
      :line-item-custom="lineItemCustom"
      :required="custom.required"
      :custom-input-id="customInputId"
      :custom-input-name="customInputName"
      :without-customization="withoutCustomization"
    />
    <custom-color-input
      v-else-if="type === 'color'"
      ref="input"
      v-model="inputValue"
      :custom="custom"
      :options="custom.available_colors"
      :required="custom.required"
      :custom-input-id="customInputId"
      :custom-input-name="customInputName"
      :without-customization="withoutCustomization"
    />
    <client-only v-else-if="type === 'image'">
      <custom-picture-input
        ref="input"
        v-model="inputValue"
        :custom="custom"
        :material="material"
        :required="custom.required"
        :without-customization="withoutCustomization"
      />
    </client-only>

    <custom-engine-input
      v-if="$store.state.userInteracted && type === 'engine'"
      ref="input"
      v-model="inputValue"
      :stock-alert="stockAlert"
      :custom="custom"
      :material="material"
      :required="custom.required"
      :out-of-stock="outOfStock"
      :without-customization="withoutCustomization"
      :line-item-editor="lineItemEditor"
      :mockups="mockups"
      :is-submiting="isSubmiting"
      @quantityUpdated="(quantity) => this.$emit('quantityUpdated', quantity)"
    />
  </span>
</template>

<script>
import BaseInput from '~/components/product/form/BaseInput'
import CustomTextInput from '~/components/product/form/custom-text-input'
import CustomColorInput from '~/components/product/form/custom-color-input'

const CustomEngineInput = () =>
  import(
    /* webpackChunkName: "custom-engine-input" */ '~/components/product/form/custom-engine-input'
  )

/** Lazy import component only when  is on client side */
const CustomPictureInput = () =>
  process.client
    ? import(
        /* webpackChunkName: "picture-input" */ '~/components/product/form/custom-picture-input'
      )
    : {}

export default {
  name: 'CustomInput',
  components: {
    CustomTextInput,
    CustomColorInput,
    CustomPictureInput,
    CustomEngineInput,
  },
  extends: BaseInput,
  props: {
    stockAlert: {
      type: Boolean,
      default: false,
    },
    lineItemEditor: {
      type: Boolean,
      default: false,
    },
    /** Customization type */
    type: {
      type: String,
      required: true,
      validator: (v) =>
        ['text', 'email', 'color', 'engine', 'image'].includes(v),
    },
    /** Spree customization */
    custom: {
      type: Object,
      required: true,
    },
    /** Produtct material slug */
    material: {
      type: String,
      default: '',
    },
    /** Overrides input id */
    customInputId: {
      type: String,
      default: null,
    },
    /** Overrides input name */
    customInputName: {
      type: String,
      default: null,
    },
    /** Whether product is in stock or not */
    outOfStock: {
      type: Boolean,
      required: true,
    },
    /** Line item customization */
    lineItemCustom: {
      type: Object,
      default: () => {},
    },
    withoutCustomization: {
      type: Boolean,
      default: false,
    },
    /** Formatted mockups for render in engines */
    mockups: {
      type: Array,
      default: () => [],
    },
    isSubmiting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startEngineByUser: false,
    }
  },
  watch: {
    inputValue(newValue) {
      this.$emit('updateCustomValue', {
        customizationValue: newValue,
        customizationCode: this.custom.code,
      })
    },
  },
  created() {
    if (this.custom.line_item_customization) {
      this.inputValue = this.custom.line_item_customization.value
    }
  },
  /** Must keep this method here */
  methods: {
    validate() {
      return this.$refs.input.validate()
    },
  },
}
</script>
